import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Datepicker, Input } from '../../../form';

export type BaseProspectusFieldsType = {
  fileNumber: string;
  dateOfApproval: Date;
};

export type BaseProspectusFieldsProps = {
  controlId: string;
};

export const BaseProspectusFields: React.FC<React.PropsWithChildren<BaseProspectusFieldsProps>> = ({ controlId }) => {
  return (
    <Row className="base-prospectus-fields">
      <Col xs={12} lg={4}>
        <Input
          type="text"
          label="CSSF file number"
          controlId={`${controlId}.fileNumber`}
          required={true}
          additionalAttributes={{ maxLength: 8 }}
        />
      </Col>
      <Col xs={12} lg={4}>
        <Datepicker label="Date of approval" controlId={`${controlId}.dateOfApproval`} required={true} />
      </Col>
    </Row>
  );
};
